export default __webpack_public_path__ + "static/media/callback_islamic.b9c39887.gif";